import * as yup from 'yup'
import { defineMessages } from 'react-intl'

const messages = defineMessages({
  required: {
    id: 'dictionary.required',
    defaultMessage: 'Required'
  }
})

const companyMessages = defineMessages({
  required: {
    id: 'fareRules.form.company.required',
    defaultMessage: 'The company is required'
  }
})

const nameMessages = defineMessages({
  required: {
    id: 'fareRules.form.name.required',
    defaultMessage: 'The name is required'
  },
  max: {
    id: 'fareRules.form.name.max',
    defaultMessage: 'The name can be up to 100 characters'
  }
})

const descriptionMessages = defineMessages({
  max: {
    id: 'inventoryRules.form.descriptions.max',
    defaultMessage: 'The description can be up to 100 characters'
  }
})

const priceMessages = defineMessages({
  required: {
    id: 'fareRules.form.price.required',
    defaultMessage: 'The price is required'
  }
})

const originMessages = defineMessages({
  required: {
    id: 'fareRules.form.origin.required',
    defaultMessage: 'The origin is required'
  }
})

const destinationMessages = defineMessages({
  required: {
    id: 'fareRules.form.destination.required',
    defaultMessage: 'The destination is required'
  }
})

const segmentsMessages = defineMessages({
  required: {
    id: 'fareRules.form.segments.required',
    defaultMessage: 'You need to select at least one valid segment'
  }
})

const routeServicesMessages = defineMessages({
  required: {
    id: 'fareRules.form.routeServices.required',
    defaultMessage: 'You need to select at least one service'
  }
})

export const schema = (intl: TSFixMe): TSFixMe => {
  return yup.object().shape({
    company: yup.object().shape({
      id: yup.string().required(intl.formatMessage(companyMessages.required))
    }),
    name: yup
      .string()
      .required(intl.formatMessage(nameMessages.required))
      .max(100, intl.formatMessage(nameMessages.max)),
    description: yup.string().max(100, intl.formatMessage(descriptionMessages.max)),
    price: yup.string().required(intl.formatMessage(priceMessages.required)),
    departureAtRanges: yup.array().of(
      yup.object().shape({
        startAt: yup.string().required(intl.formatMessage(messages.required)),
        endAt: yup.string().required(intl.formatMessage(messages.required))
      })
    ),
    activationAtRanges: yup.array().of(
      yup.object().shape({
        startAt: yup.string().required(intl.formatMessage(messages.required)),
        endAt: yup.string().required(intl.formatMessage(messages.required))
      })
    ),
    origin: yup.object().shape({
      id: yup.string().required(intl.formatMessage(originMessages.required))
    }),
    destination: yup.object().shape({
      id: yup.string().required(intl.formatMessage(destinationMessages.required))
    }),
    segments: yup.array().min(1, intl.formatMessage(segmentsMessages.required)),
    routeServices: yup.array().min(1, intl.formatMessage(routeServicesMessages.required))
  })
}
